__turbopack_context__.v({
  "label": "FieldLabel-module-scss-module__OcYUoa__label",
});
